<template>
  <div :class="this['class']">
    <slot></slot>
  </div>
</template>

<script>
export default {
	name: 'column',
	props: {
		'class': {
			type: String,
			default: ''
		}
	},
	created () {

	}
}
</script>



// WEBPACK FOOTER //
// Column.vue?2bb81cce